import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
    url?: string;
    image?: string;
    type?: string;
}

const SEO = ({ 
    title = "River Hawk Chapter - Order of the Arrow", 
    description = "River Hawk Chapter of Nentico Lodge 12, Order of the Arrow. Serving scouts in the River Hawk District of the Baltimore Area Council.",
    keywords = "River Hawk Chapter, Order of the Arrow, Nentico Lodge 12, Baltimore Area Council, Boy Scouts, Scouting, Service, Fellowship, Brotherhood, OA",
    url,
    image = "https://riverhawkoa.org/logo512.png",
    type = "website"
}: SEOProps) => {
    const location = useLocation();
    const canonicalUrl = url || `https://riverhawkoa.org${location.pathname}`;
    
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            
            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            
            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={canonicalUrl} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            
            {/* Canonical URL */}
            <link rel="canonical" href={canonicalUrl} />
        </Helmet>
    );
};

export default SEO;